import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-cream overflow-hidden pt-8 pb-12 lg:pt-24 lg:pb-32 px-4 sm:px-6 lg:px-8" data-id="element-137">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-cream-dark/30 to-transparent pointer-events-none" data-id="element-138" />
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-139" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-140">
        {/* Left Column: Copy */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-start z-10" data-id="element-141">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-china-red/10 border border-china-red/20 text-china-red text-sm font-medium mb-4 lg:mb-6 tracking-wide" data-id="element-142">
            <span className="w-2 h-2 rounded-full bg-china-red mr-2 animate-pulse" data-id="element-143"></span>
            Guía Práctica 2026
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-charcoal leading-tight mb-3 lg:mb-4 tracking-tight" data-id="element-144">
            Viajar a China{' '}
            <span className="text-china-red italic" data-id="element-145">Sin Estrés</span>
          </h1>

          <h2 className="text-lg sm:text-xl lg:text-2xl text-charcoal-light font-medium mb-4 lg:mb-6 font-serif italic" data-id="element-146">
            Ruta Real + Apps + Pagos (para españoles)
          </h2>

          <p className="text-base lg:text-lg text-charcoal/80 mb-5 lg:mb-8 max-w-xl leading-relaxed" data-id="element-147">
            Tu{' '}
            <span className="font-semibold text-china-red" data-id="element-148">
              Kit Anti-Bloqueo
            </span>{' '}
            + itinerarios 7/10/14/21 días. Diseñado para ritmo medio y estilo
            práctico.
          </p>

          <ul className="space-y-3 lg:space-y-4 mb-6 lg:mb-10 w-full max-w-lg" data-id="element-149">
            {['Primera vez en China, viajas por libre', 'Quieres pagar con el móvil y no improvisar', 'PDF + checklists imprimibles + plantillas'].map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3 + index * 0.1
          }} className="flex items-start" data-id="element-150">
                <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gold/20 flex items-center justify-center mt-0.5 mr-3" data-id="element-151">
                  <Check className="h-3.5 w-3.5 text-charcoal" strokeWidth={3} data-id="element-152" />
                </div>
                <span className="text-charcoal-light" data-id="element-153">{item}</span>
              </motion.li>)}
          </ul>

          <div className="flex flex-col sm:flex-row items-center gap-6 w-full sm:w-auto" data-id="element-154">
            <motion.button onClick={() => document.getElementById('checkout')?.scrollIntoView({
            behavior: 'smooth'
          })} whileHover={{
            scale: 1.02,
            boxShadow: '0 10px 25px -5px rgba(155, 27, 48, 0.3)'
          }} whileTap={{
            scale: 0.98
          }} className="w-full sm:w-auto px-8 py-4 bg-china-red text-cream font-semibold text-lg rounded-lg shadow-lg hover:bg-china-red-dark transition-all duration-300 flex items-center justify-center group" data-id="element-155">
              Quiero mi Kit Anti-Bloqueo
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-156" />
            </motion.button>

            <div className="flex flex-col items-center sm:items-start" data-id="element-157">
              <div className="flex items-center" data-id="element-158">
                <div className="relative" data-id="element-159">
                  <div className="absolute inset-0 bg-gold/20 rotate-3 rounded-md" data-id="element-160"></div>
                  <div className="relative bg-white border border-gold/30 px-3 py-1 rounded-md shadow-sm" data-id="element-161">
                    <span className="text-2xl font-bold text-china-red font-serif" data-id="element-162">
                      24€
                    </span>
                  </div>
                </div>
                <span className="ml-3 text-sm text-charcoal-light font-medium" data-id="element-163">
                  Descarga inmediata
                </span>
              </div>
            </div>
          </div>

          <div className="mt-5 lg:mt-8 flex items-center gap-2 text-sm text-charcoal/60" data-id="element-164">
            <div className="flex text-gold" data-id="element-165">
              <Star className="h-4 w-4 fill-current" data-id="element-166" />
              <Star className="h-4 w-4 fill-current" data-id="element-167" />
              <Star className="h-4 w-4 fill-current" data-id="element-168" />
              <Star className="h-4 w-4 fill-current" data-id="element-169" />
              <Star className="h-4 w-4 fill-current" data-id="element-170" />
            </div>
            <span data-id="element-171">Actualizado para viajeros 2026</span>
          </div>
        </motion.div>

        {/* Right Column: Mockup */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="relative z-10 flex justify-center lg:justify-end" data-id="element-172">
          <motion.div animate={{
          y: [0, -15, 0]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} className="relative w-full max-w-md lg:max-w-full" data-id="element-173">
            <div className="absolute inset-0 bg-gold/20 blur-[60px] rounded-full transform translate-y-10 scale-90 opacity-60" data-id="element-174"></div>
            <img src="https://cdn.magicpatterns.com/uploads/i4LimDWX9JF6MEdQBijCEn/guiachina_mockup.png" alt="China Sin Estrés Guide Mockup" className="relative w-full h-auto drop-shadow-2xl transform rotate-1 hover:rotate-0 transition-transform duration-700" data-id="element-175" />
          </motion.div>
        </motion.div>
      </div>

      {/* Bottom wave decoration */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-176">
        <svg className="relative block w-full h-[40px] text-white" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-177">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-current" data-id="element-178"></path>
        </svg>
      </div>
    </section>;
}